import { render, staticRenderFns } from "./PricingPortal.vue?vue&type=template&id=0df499c4&"
import script from "./PricingPortal.vue?vue&type=script&lang=js&"
export * from "./PricingPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports